module.exports = __webpack_public_path__ + "img/Hybrid-bridge.f62264e1.jpg";